import React from "react";
import Image from "../assets/IAM-Advisory-1.png";
import { Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { FaQuoteLeft } from "react-icons/fa";
import { FaQuoteRight } from "react-icons/fa";
import { SiTicktick } from "react-icons/si";
import BG from "../assets/Blue.png";
import Footer from "../components/Footer";
import '../utils/effectCSS/Effects.css';

const AccessManagement = () => {
  return (
    <>
      <Container
        fluid
        className="py-5"
        style={{
          backgroundImage: "url(" + BG + ")",
        }}
      >
        <div
          style={{
            height: "70px",
          }}
        ></div>
        <h2 className="text-center p-4">
          <b>Access Management</b>
        </h2>

        <hr
          className="d-flex justify-content-center"
          style={{
            width: "10%",
            border: "1.5px solid blue",
            margin: "0 auto",
          }}
        />

        <div className="mt-5">
          <Row>
            <Col lg={2} className="d-flex justify-content-end">
              <FaQuoteLeft
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>

            <Col lg={8}>
              <Container fluid className="text-center">
                <p
                  style={{
                    fontSize: "1.25rem",
                  }}
                >
                  Avoid sacrificing security or letting dispersed logins interfere with your business operations. With IDM 360 Analytics's professional access management solutions, you can give your staff and clients easy access and strong data protection. Accept a future with increased Efficiency and Security.
                </p>
              </Container>
            </Col>

            <Col
              lg={2}
              className="d-flex align-items-start justify-content-start"
            >
              <FaQuoteRight
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>
          </Row>
        </div>
        <Container>
          <Row className="mt-5 align-items-stretch">
            <Col className="d-flex" lg={6} xs={12}>
              <img className="img-fluid" src={Image} alt="IAM" />
            </Col>
            <Col className="d-flex" lg={6} xs={12}>
              <Container
                className="flex-fill"
                style={{
                  backgroundColor: "#6495ED",
                  color: "white",
                  padding: "4rem 2rem",
                }}
              >
                <h4 className="">Your ROI with IDM 360 Analytics</h4>

                <div className="mt-2">
                  <ListGroup className="border-0 bg-transparent ">
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Adaptive Authentication: Utilize cutting-edge tools to
                      dynamically tailor authentication requirements based on
                      user behavior and associated risk factors.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Continuous Monitoring and Threat Detection: Proactively
                      identify and neutralize unauthorized access attempts and
                      suspicious activity.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      User-Centric Experience: Deliver intuitive interfaces and
                      streamlined workflows for a seamless and secure access
                      experience.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Expert Guidance and Support: Our team of IAM specialists
                      work closely with you to design and implement a solution
                      tailored to your unique needs and objectives.
                    </ListGroup.Item>
		    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Proven Success Record: IDM 360 Analytics’s solutions have a proven track record of delivering measurable results, helping organizations reduce security 		      incidents and improve overall operational efficiency.
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              </Container>
            </Col>
          </Row>
        </Container>
        <Card className="bg-transparent border border-0 text-black p-5 text-center">
          <Card.Body>
            <h3 className="text-center mb-4">
              <b>Gain control over Access, Empowering Your Employees and Customers</b>
            </h3>
            <hr
              className="d-flex justify-content-center"
              style={{
                width: "10%",
                border: "1.5px solid blue",
                margin: "0 auto",
              }}
            />
            <Container>
              <Row xs={1} lg={3}>
                <Col lg={2}></Col>
                <Col lg={8} className="mt-4">
                  <p
                    style={{
                      fontSize: "1.25rem",
                    }}
                  >
                    Access management today is a complex process that goes beyond basic tasks. It requires a perfect blend of robust security, streamlined efficiency, and empowered users. Move away from cumbersome keychains and inflexible firewalls — IDM 360 Analytics focuses on delivering dynamic access management solutions that achieve this delicate equilibrium with precision.
                  </p>
                </Col>
                <Col lg={2}></Col>
              </Row>
            </Container>
          </Card.Body>
        </Card>

        <Container className="p-0">
          {/* First Row */}
          <Row className="justify-content-center g-3 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>Passwordless</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  We provide advanced passwordless authentication solutions that enhance security while simplifying the user experience. By eliminating the need for traditional passwords, we enable seamless and secure access through biometrics, smart devices, or multi-factor authentication, reducing the risk of password-related breaches and improving overall efficiency.
                </p>
              </Container>
            </Col>
          </Row>
          {/* Second Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={6} className="d-flex order-2 order-lg-1 hover-left">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  IDM 360 Analytics offers Single Sign-On (SSO) solutions that streamline access to multiple applications with a single set of credentials. By simplifying authentication, SSO improves user experience, boosts productivity, and enhances security by reducing password fatigue and ensuring centralized control over user access to critical systems.
                </p>
              </Container>
            </Col>

            <Col lg={4} className="d-flex order-1 order-lg-2 hover-right">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#1ca9c9",
                  color: "white",
                }}
              >
                <h5>SSO</h5>
              </Container>
            </Col>
          </Row>
          {/* Third Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>Lifecycle Management</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  Optimize your identity and access processes with IDM 360 Analytics' Lifecycle Management solutions. We provide a complete solution for managing user access, ensuring compliance, and minimizing risks, while automating the entire lifecycle from provisioning to deprovisioning for maximum efficiency. Our solutions ensure seamless workflows, enhance security, and reduce the complexity of identity management across your organization.
                </p>
              </Container>
            </Col>
          </Row>
          {/* Fourth Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={6} className="d-flex order-2 order-lg-1 hover-left">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  we specialize in creating secure and scalable Digital Identity solutions tailored to meet the evolving needs of modern enterprises. Our comprehensive approach empowers organizations to securely manage and authenticate users, streamline access to digital services with regulatory requirements. By leveraging advanced technologies, we enable businesses to build trust, enhance user experiences, and protect sensitive data.                </p>
              </Container>
            </Col>

            <Col lg={4} className="d-flex order-1 order-lg-2 hover-right">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#1ca9c9",
                  color: "white",
                }}
              >
                <h5>Digital Identity</h5>
              </Container>
            </Col>
          </Row>
          {/* Fifth Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>Zero Trust</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  We help organizations implement a robust Zero Trust security model that continuously verifies every user and device, ensuring that no one is trusted by default—inside or outside the network. Our solutions enforce stringent access policies and real-time monitoring, minimizing risks and providing comprehensive protection for your critical assets and data.
                </p>
              </Container>
            </Col>
          </Row>
        </Container>
      </Container>
      <div className="mt-4">
        <Footer />
      </div>
    </>
  );
};

export default AccessManagement;
